<template>
    <div class="" style="margin:0 -12px;">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-3" style="padding-top:8px;">
                        <i class="bi bi-x" style="font-size:30px;color:#b3b3b3;"
                            onclick="window.history.back()"></i>
                    </div>
                    <div class="col px-0 text-center">
                        <div style="padding-top:20px; ">
                            <b>プロフィール画像の変更</b>
                        </div>
                    </div>
                    <div class="col-3 text-end">
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap" v-if="user">
            <div class="container" style="padding-top:56px;">
                <div class="row" style="background:#E7E7FF;">
                    <MyIconValidationContainer class="validation-container" v-if="!user.icon_url && user.is_sex === 1" />
                    <div class="col" style="padding-top:10px;padding-bottom:10px">
                        <b>メイン画像</b>
                    </div>
                </div>
                <br>
                <div class="row justify-content-center">
                    <div class="col-8 text-center">
                        <img src="/images/icon_user.png" style="width:100%;" class="icon_sub_box"
                            v-if="user.icon_url == null" />
                        <img :src="user.icon_url" style="width:100%;" class="icon_main_box" v-else />
                        <div class="row">
                            <div class="col text-canter">
                                <button type="button" class="btn btn-luna"
                                    style="font-size:10px;background-color: #fff;border-color: #fff;color: #6b4eff;position: relative;top: -40px;"
                                    @click="showIconUrl(1)"><i class="bi bi-camera"></i>&nbsp;画像を変更</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-10 text-center">
                        <p style="color:red;font-size:10px;">※ 明らかに卑猥なイメージやわいせつな行為を明示する写真等を登録された場合は、運営が画像を差し替える場合があります。
                        </p>
                    </div>
                </div>
                <br>
                <div class="row justify-content-center">
                    <div class="col-8">
                        <div class="d-grid gap-2">
                            <button type="button" class="btn btn-luna" style="padding:20px 0;" @click="upImage()">
                                <div class="spinner-border" style="width: 1rem; height: 1rem;" role="status"
                                    v-if="is_load">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                                保存する
                            </button>
                        </div>
                    </div>
                </div>
                <br>
                <br>
                <div v-if="user.can_use_all_features">
                    <div class="row" style="background:#E7E7FF;">
                        <div class="col" style="padding-top:10px;padding-bottom:10px">
                            <b>サブ画像</b>
                        </div>
                    </div>
                    <br>
                    <div class="row ">
                        <div class="col-6">
                            <img src="/images/icon_user.png" style="width:100%;" class="icon_sub_box"
                                v-if="user.sub_icon_url1 == null" />
                            <img src="/images/icon_user.png" style="width:100%;" class="icon_sub_box"
                                v-else-if="user.sub_icon_url1 == ''" />
                            <img :src="user.sub_icon_url1" style="width:100%;" class="icon_sub_box" v-else />
                            <div class="row justify-content-center">
                                <div class="col-5 text-start">
                                    <button type="button" class="btn btn-luna-d"
                                        style="font-size:10px;position: relative;top: -40px;"
                                        @click="rmImage(1)">削除</button>
                                </div>
                                <div class="col-5 text-end">
                                    <button type="button" class="btn btn-luna"
                                        style="font-size:10px;background-color: #a99af3;border-color: #a99af3;color: #fff;position: relative;top: -40px;"
                                        @click="showIconUrl(2)">変更</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <img src="/images/icon_user.png" style="width:100%;" class="icon_sub_box"
                                v-if="user.sub_icon_url2 == null" />
                            <img src="/images/icon_user.png" style="width:100%;" class="icon_sub_box"
                                v-else-if="user.sub_icon_url2 == ''" />
                            <img :src="user.sub_icon_url2" style="width:100%;" class="icon_sub_box" v-else />
                            <div class="row justify-content-center">
                                <div class="col-5 text-start">
                                    <button type="button" class="btn btn-luna-d"
                                        style="font-size:10px;position: relative;top: -40px;"
                                        @click="rmImage(2)">削除</button>
                                </div>
                                <div class="col-5 text-end">
                                    <button type="button" class="btn btn-luna"
                                        style="font-size:10px;background-color: #a99af3;border-color: #a99af3;color: #fff;position: relative;top: -40px;"
                                        @click="showIconUrl(3)">変更</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <img src="/images/icon_user.png" style="width:100%;" class="icon_sub_box"
                                v-if="user.sub_icon_url3 == null" />
                            <img src="/images/icon_user.png" style="width:100%;" class="icon_sub_box"
                                v-else-if="user.sub_icon_url3 == ''" />
                            <img :src="user.sub_icon_url3" style="width:100%;" class="icon_sub_box" v-else />
                            <div class="row justify-content-center">
                                <div class="col-5 text-start">
                                    <button type="button" class="btn btn-luna-d"
                                        style="font-size:10px;position: relative;top: -40px;"
                                        @click="rmImage(3)">削除</button>
                                </div>
                                <div class="col-5 text-end">
                                    <button type="button" class="btn btn-luna"
                                        style="font-size:10px;background-color: #a99af3;border-color: #a99af3;color: #fff;position: relative;top: -40px;"
                                        @click="showIconUrl(4)">変更</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <img src="/images/icon_user.png" style="width:100%;" class="icon_sub_box"
                                v-if="user.sub_icon_url4 == null" />
                            <img src="/images/icon_user.png" style="width:100%;" class="icon_sub_box"
                                v-else-if="user.sub_icon_url4 == ''" />
                            <img :src="user.sub_icon_url4" style="width:100%;" class="icon_sub_box" v-else />
                            <div class="row justify-content-center">
                                <div class="col-5 text-start">
                                    <button type="button" class="btn btn-luna-d"
                                        style="font-size:10px;position: relative;top: -40px;"
                                        @click="rmImage(4)">削除</button>
                                </div>
                                <div class="col-5 text-end">
                                    <button type="button" class="btn btn-luna"
                                        style="font-size:10px;background-color: #a99af3;border-color: #a99af3;color: #fff;position: relative;top: -40px;"
                                        @click="showIconUrl(5)">変更</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-center">
                        <div class="col-8">
                            <div class="d-grid gap-2">
                                <button type="button" class="btn btn-luna" style="padding:20px 0;" @click="upImage()">
                                    <div class="spinner-border" style="width: 1rem; height: 1rem;" role="status"
                                        v-if="is_load">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                    保存する
                                </button>
                            </div>
                        </div>
                    </div>
                    <br>
                    <br>
                </div>
                <br>
                <br>
            </div>
        </div>
        <modal name="modal-icon" :draggable="false" :resizable="false" width="350px" height="450px">
            <div class="container">
                <div class="row">
                    <div class="col text-end" style="padding-top:10px;">
                        <span style="color:#6C7072;font-size:18px;z-index:999;" v-on:click="hideIconUrl">
                            <i class="bi bi-x-circle"></i>
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center">
                        <croppa v-model="iconUrlCroppa" :width="300" :height="300" placeholder=""
                            :placeholder-font-size="0" :disabled="false" :prevent-white-space="false"
                            :show-remove-button="true" accept=".jpeg,.jpg,.png"
                            @file-type-mismatch="onFileTypeMismatch">
                            <img slot="placeholder" src="/images/Group13197.png" height="300">
                        </croppa>
                        <div style="padding:5px 0;">
                            <button type="button" class="btn btn-luna" style="font-size: 18px;"
                                @click="iconUrlCroppa.rotate()"><i class="bi bi-arrow-clockwise"></i>
                            </button>
                        </div>
                        <button class="btn btn-luna-d" v-if="iconUrlCroppa == null">
                            アップロード
                        </button>
                        <button class="btn btn-luna-d" v-else-if="!iconUrlCroppa.generateDataUrl()">
                            アップロード
                        </button>
                        <button class="btn btn-luna" @click="generateImage" v-else>
                            <div class="spinner-border" style="width: 1rem; height: 1rem;" role="status" v-if="is_load">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            アップロード
                        </button>
                    </div>
                </div>

            </div>
        </modal>
    </div>
</template>

<script>
import MyIconValidationContainer from "../components/Trial/MyIconValidationContainer/index.vue";

export default {
    components: {
        MyIconValidationContainer
    },
    data() {
        return {
            user: {
                id: null,
                icon_url: null,
                sub_icon_url1: null,
                sub_icon_url2: null,
                sub_icon_url3: null,
                sub_icon_url4: null,
                can_use_all_features: false,
                is_sex: null,
            },
            area_list: [],
            age_list: [],
            sex_list: [],
            iconUrlCroppa: null,
            file_icon: null,
            file_sub_icon_1: null,
            file_sub_icon_2: null,
            file_sub_icon_3: null,
            file_sub_icon_4: null,
            is_load: false,
            type: "",
            modal_img_type: 0,
        };
    },
    methods: {
        onFileTypeMismatch(file) {
            alert('jpg, gif, png　形式でアップして下さい。')
        },
        async generateImage() {

            let url = this.iconUrlCroppa.generateDataUrl();
            if (!url) {
                alert("画像を選択してください");
                return;
            }

            let bin = atob(url.replace(/^.*,/, ''));
            let buffer = new Uint8Array(bin.length);
            for (let i = 0; i < bin.length; i++) {
                buffer[i] = bin.charCodeAt(i);
            }

            if (this.modal_img_type == 1) {
                this.user.icon_url = url
                this.file_icon = new Blob([buffer.buffer], {
                    type: "image/jpeg"
                });
            }
            else if (this.modal_img_type == 2) {
                this.user.sub_icon_url1 = url
                this.file_sub_icon_1 = new Blob([buffer.buffer], {
                    type: "image/jpeg"
                });
            }
            else if (this.modal_img_type == 3) {
                this.user.sub_icon_url2 = url
                this.file_sub_icon_2 = new Blob([buffer.buffer], {
                    type: "image/jpeg"
                });
            }
            else if (this.modal_img_type == 4) {
                this.user.sub_icon_url3 = url
                this.file_sub_icon_3 = new Blob([buffer.buffer], {
                    type: "image/jpeg"
                });
            }
            else if (this.modal_img_type == 5) {
                this.user.sub_icon_url4 = url
                this.file_sub_icon_4 = new Blob([buffer.buffer], {
                    type: "image/jpeg"
                });
            }

            this.hideIconUrl()
        },
        showIconUrl(t) {
            //window.location.href = "/user/icon/" + this.user.id + "/" + t
            this.modal_img_type = t
            this.$modal.show('modal-icon');
        },
        hideIconUrl() {
            this.$modal.hide('modal-icon');
        },
        async upImage() {
            this.is_load = true

            let config = {
                headers: {
                    "content-type": "multipart/form-data",
                },
            };

            if (this.file_icon != null) {

                let formData = new FormData();
                formData.append("file", this.file_icon);

                let response = await axios
                    .post("/api/user/up/icon", formData, config)
                    .catch((error) => {
                        if (error.response && error.response.status == 401) {
                            window.location.href = "/auth?logout=true"
                        }
                        else {
                            this.$showErrorToast("画像のアップロードに失敗しました")
                        }
                    })
            }

            if (this.file_sub_icon_1 != null) {

                let formData = new FormData();
                formData.append("file", this.file_sub_icon_1);

                let response = await axios
                    .post("/api/user/up/sub_icon_1_", formData, config)
                    .catch((error) => {
                        if (error.response && error.response.status == 401) {
                            window.location.href = "/auth?logout=true"
                        }
                        else {
                            this.$showErrorToast("画像のアップロードに失敗しました", false)
                        }
                    })
            }

            if (this.file_sub_icon_2 != null) {

                let formData = new FormData();
                formData.append("file", this.file_sub_icon_2);

                let response = await axios
                    .post("/api/user/up/sub_icon_2_", formData, config)
                    .catch((error) => {
                        if (error.response && error.response.status == 401) {
                            window.location.href = "/auth?logout=true"
                        }
                        else {
                            this.$showErrorToast("画像のアップロードに失敗しました")
                        }
                    })
            }

            if (this.file_sub_icon_3 != null) {

                let formData = new FormData();
                formData.append("file", this.file_sub_icon_3);

                let response = await axios
                    .post("/api/user/up/sub_icon_3_", formData, config)
                    .catch((error) => {
                        if (error.response && error.response.status == 401) {
                            window.location.href = "/auth?logout=true"
                        }
                        else {
                            this.$showErrorToast("画像のアップロードに失敗しました")
                        }
                    })
            }

            if (this.file_sub_icon_4 != null) {

                let formData = new FormData();
                formData.append("file", this.file_sub_icon_4);

                let response = await axios
                    .post("/api/user/up/sub_icon_4_", formData, config)
                    .catch((error) => {
                        if (error.response && error.response.status == 401) {
                            window.location.href = "/auth?logout=true"
                        }
                        else {
                            this.$showErrorToast("画像のアップロードに失敗しました")
                        }
                    })
            }
            this.is_load = false
            this.fetchUsers()
        },
        async rmImage(s) {
            let response = await axios.get("/api/user/rm/" + s)
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("画像の削除に失敗しました")
                    }
                })
            this.fetchUsers()
        },
        async init() {
            await axios.get("/api/auth/user/get")
                .then(
                    () => {
                        this.fetchUsers()
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
        async fetchUsers() {
            await axios.get("/api/user/get/me")
                .then((response) => {
                    this.user = response.data.user

                    this.imgUrl = this.user.icon_url
                    this.area_list = response.data.area_list
                    this.age_list = response.data.age_list
                    this.sex_list = response.data.sex_list
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.init()
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                this.init()
            }
        }
        else {
            this.init()
        }
    },
}
</script>
<style scoped>
.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    height: 56px;
    width: 540px;
    top: 0;
    background-color: #fff;
    z-index: 999;
}

.validation-container {
    padding-left: 0px;
    padding-right: 0px;
}

@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}

.icon_main_box {
    border-radius: 20px;
    box-shadow: 0px 0px 20px -5px rgba(0, 0, 0, 0.35);
}

.icon_sub_box {
    border-radius: 5px;
}

.croppa-container {
    background-color: #fff;
    border-radius: 8px;
}
</style>
